import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { unwrap, type ApiEnvelope } from '../lib/api-envelope';
import { LOAD_FAILURE_QUERY_OPTIONS } from '../lib/load-failure';
import type { DriverHosSummary } from '../types/driver-hos';

/**
 * The signed-in driver's hours of service (GET /trucking/drivers/me/hos).
 *
 * One query key for every readout, so the profile recap and the load-view chip
 * read one request. A null figure means no logs in the 7-day window: render it
 * as a dash, never as 0 used or a full cycle left.
 */
export function useMyHos() {
  return useQuery({
    queryKey: ['driver-hos'],
    queryFn: () =>
      apiClient
        .get<ApiEnvelope<DriverHosSummary>>('/trucking/drivers/me/hos')
        .then((r) => unwrap<DriverHosSummary>(r.data)),
    staleTime: 30_000,
    ...LOAD_FAILURE_QUERY_OPTIONS,
  });
}
